import { BaseRepository } from '../BaseRepository';
import { BFF_ENDPOINTS, type BffEndpoint } from '../../endpoints/BffEndpoints';
import type { HttpResponse } from '../../http/HttpClient';
import type { ValidateEmailPayload, ValidateEmailResponse } from '../../models/bff/Registration';
import { BffApiClient } from '../../clients/BffApiClient';

const NAME = 'registrations';

/**
 * RegistrationRepository class for handling registration-related API operations.
 * Uses the BFF API client by default but can be switched to other API clients.
 * Type-safe: Only allows BFF endpoints defined in BFF_ENDPOINTS.
 */
export class RegistrationRepository extends BaseRepository<BffEndpoint> {
  static override readonly name = NAME;

  constructor() {
    super(BffApiClient.getInstance());
  }

  /**
   * Validate an email address for registration.
   * Returns 202 (Accepted) for valid emails with no response body.
   * Returns 400 (Bad Request) with error details for invalid emails.
   *
   * @param request - The email validation request
   * @returns Promise<HttpResponse<ValidateEmailResponse>> - Empty response for valid emails
   * @throws HttpError with ValidateEmailErrorResponse for invalid emails (400 status)
   */
  validateEmail(request: ValidateEmailPayload): Promise<HttpResponse<ValidateEmailResponse>> {
    return this.apiClient.post<ValidateEmailResponse>(
      BFF_ENDPOINTS.VALIDATE_EMAIL,
      request,
    );
  }
}

declare module '../Repositories' {
  export interface Repositories {
    [NAME]: RegistrationRepository;
  }
}